import { usePublish, useView } from '@10000/react'
import { useStack } from '../layout'
import { Box, Button } from '../widgets'
import { Subscriptions } from '../onboarding/payment'

// it is assumed this component is used from within a squiz
export const SubscribeButton = ({ p = '0 32px 16px', displayMode }) => {
  const publish = usePublish('tenant')
  const { options, presenter } = useView('squiz')
  const { subscription: { signupStarted } = {} } = useView('tenant')
  const { parent } = useStack()

  const subscribe = () => {
    if(!signupStarted) {
      publish('signupStarted')
    }
    parent.push([{ Component: Subscriptions, props: { fromFreeSquiz: true } }])
  }

  return options?.free && presenter && !displayMode && (
    <Box p={p} maxWidth="100%" zIndex={1}>
      <Button style={{ width: 480, maxWidth: '100%' }} onClick={subscribe}>
        Subscribe
      </Button>
    </Box>
  )
}